import { styled } from "@mui/material";
import Grid from "@mui/material/Grid";
import ReadonlyFeeScheduleCategoriesTable from "_shared/fee-schedules/categories/_views/readonly-fee-schedule-categories-table";
import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { useEffect, useState } from "react";
import { FeeScheduleCategoryMaskedCurrency, Masked } from "work/_shared/masked-fields";
import CommentThread from "work/proposals/comments/threads/comment-thread";
import Proposal from "work/proposals/proposal";
import ProposalField, {
  ProposalFieldCategory,
  ProposalFieldCategoryType,
} from "work/proposals/proposal-fields/proposal-field";

const ListContainer = styled(Grid)(() => ({
  minHeight: "20rem",
}));
const CategorySelection = styled(ReadonlyFeeScheduleCategoriesTable)(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    marginTop: theme.spacing(2),
  },
  height: "100%",
  marginLeft: theme.spacing(2),
}));

type FeeScheduleArchivedProps = {
  activeTab: ProposalFieldCategoryType;
  proposal: Proposal;
  commentThreads?: CommentThread[];
  onCommentsClicked: (field: ProposalField, name?: string) => void;
};

export default function FeeScheduleArchivedTab(props: Readonly<FeeScheduleArchivedProps>) {
  const { activeTab, proposal, commentThreads, onCommentsClicked } = props;

  const [selectedCategories, setSelectedCategories] = useState<
    FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[]
  >([]);

  useEffect(() => {
    if (Masked.isMasked(proposal.feeSchedule)) return;
    if (activeTab !== ProposalFieldCategory.FeeSchedule) return;

    setSelectedCategories(proposal.feeSchedule ?? []);
  }, [proposal, activeTab]);

  if (activeTab !== ProposalFieldCategory.FeeSchedule) return null;
  if (Masked.isMasked(proposal.feeSchedule)) {
    return "You do not have permission to view the fee schedule.";
  }

  return (
    <ListContainer container direction="row">
      <Grid size="grow">
        <CategorySelection
          categories={selectedCategories}
          commentThreads={commentThreads}
          onCommentsClicked={onCommentsClicked}
        />
      </Grid>
    </ListContainer>
  );
}
